<template>
  <div>
    <div :class="['box_msg', 'info']" v-if="inLoading">
      <span class="black">
        {{ i18nJS.checking_interaction }}
      </span>
      <spinner :visible="true" />
    </div>
    <div v-if="!inLoading">
      <warning-msg
        v-for="(interaction, index) in interactions"
        v-bind:key="index"
        :label="`${i18nJS.interaction_found_between} ${interaction.active_principle_1_name} - ${interaction.active_principle_2_name}`"
        :message="interaction.description"
        style="margin-top: 2px"
        :deletable="true"
        @closeEvent="closeWarning(index)"
      />
    </div>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import warningMsg from '../warningMsg';
import spinner from '../spinner';

export default {
  name: 'guestDrugsInteraction',
  props: ['guestDrugId', 'drugIds', 'isIndex', 'url'],
  components: {
    warningMsg,
    spinner,
  },
  data() {
    return {
      interactions: [],
      inLoading: false,
    };
  },
  mounted() {
    eventBus.$on('new_drug_selected_on_guest_drugs', (newDrugIds) => {
      if (newDrugIds) {
        this.inLoading = true;
        this.checkInteraction(newDrugIds);
      }
    });
    if (this.isIndex || (!this.isIndex && this.drugIds && this.drugIds.length > 0)) {
      this.inLoading = true;
      this.checkInteraction(this.drugIds);
    }
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    checkInteraction(drugIds) {
      let finalUrl = this.url;
      let drugs = [];
      if (drugIds) {
        drugs = Array.isArray(drugIds) ? drugIds : [drugIds];
        drugs.forEach((drugId) => (finalUrl = Utils.addGetParam(finalUrl, 'drug_ids[]', drugId, false)));
      }
      if (this.guestDrugId) finalUrl = Utils.addGetParam(finalUrl, 'guest_drug_id', this.guestDrugId, false);

      apiConnector()
        .get(finalUrl)
        .then(({ data }) => {
          this.interactions = data;
          this.inLoading = false;
        })
        .catch(() => {
          this.inLoading = false;
          alert('Qualcosa non ha funzionato! Ricaricare la pagina');
        });
    },
    closeWarning(index) {
      this.interactions.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-family: 'Source Sans Pro', sans-serif;
  border: 1px solid #dcdcdc;
  padding: 8px;
}
.black {
  color: black;
}
</style>
